import React from 'react';

export default function Loader({ fullscreen = false, size = 'md' }) {
  const sizes = { sm: 20, md: 32, lg: 48 };
  const s = sizes[size];

  const spinner = (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" style={{ animation: 'spin 0.8s linear infinite' }}>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <circle cx="12" cy="12" r="10" stroke="var(--gray-200)" strokeWidth="2.5"/>
      <path d="M12 2a10 10 0 0 1 10 10" stroke="var(--brand-black)" strokeWidth="2.5" strokeLinecap="round"/>
    </svg>
  );

  if (fullscreen) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'var(--brand-off-white)' }}>
      {spinner}
    </div>
  );
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '3rem' }}>
      {spinner}
    </div>
  );
}